<template>
  <form @submit.prevent="handleSubmit" enctype="multipart/form-data" novalidate>
    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="required">Nombre del profesional (quien hizo la solicitud)</label>
        <input
          v-model="form.nombres"
          class="form-control"
          :class="{ 'is-invalid': submitted && !form.nombres }"
          required
        />
      </div>
      <div class="col-md-6 mb-3">
        <label class="required">Apellidos</label>
        <input
          v-model="form.apellidos"
          class="form-control"
          :class="{ 'is-invalid': submitted && !form.apellidos }"
          required
        />
      </div>
      <div class="col-md-6 mb-3">
        <label class="required">Selecciona tu Rol</label>
        <select
          v-model="form.rol"
          class="form-select"
          :class="{ 'is-invalid': submitted && !form.rol }"
          required
        >
          <option value="">Selecciona...</option>
          <option value="odontólogo">odontólogo</option>
          <option value="estudiante">estudiante</option>
          <option value="higienista">higienista</option>
          <option value="otro">otro</option>
        </select>
      </div>
      <div class="col-md-6 mb-3" v-if="form.rol === 'otro'">
        <label>Especifica tu Rol</label>
        <input v-model="form.rol_especificado" class="form-control" placeholder="Ingresa tu rol" />
      </div>
      <div class="col-md-6 mb-3">
        <label class="required">Correo electrónico</label>
        <input
          v-model="form.email"
          type="email"
          class="form-control"
          :class="{ 'is-invalid': submitted && !form.email }"
          required
        />
      </div>
      <div class="col-md-6 mb-3">
        <label>Celular (Opcional)</label>
        <input v-model="form.celular" class="form-control" />
      </div>
      <div class="col-md-6 mb-3">
        <label class="required">¿A qué entidad pertenece?</label>
        <select
          v-model="form.tipoEntidad"
          class="form-select"
          :class="{ 'is-invalid': submitted && !form.tipoEntidad }"
          required
        >
          <option value="">Selecciona...</option>
          <option value="PUBLIC_ENTITY">Entidad pública</option>
          <option value="PRIVATE_ENTITY">Entidad privada</option>
        </select>
      </div>
      <div class="col-md-6 mb-3">
        <label class="required">Nombre de la entidad</label>
        <input
          v-model="form.nameEntity"
          class="form-control"
          :class="{ 'is-invalid': submitted && !form.nameEntity }"
          required
        />
      </div>
    </div>

    <hr />

    <div class="alert alert-info" role="alert">
      Usted Puede registrar <strong>1 o 2 organizaciones</strong>: <em>(institución, comunidad o fundación)</em>.
    </div>

    <h5>Organización 1 (obligatoria)</h5>
    <div class="mb-3">
      <label class="required">Selecciona una comunidad, institución o fundación</label>
      <select
        v-model="form.organizacion1.tipo"
        class="form-select"
        :class="{ 'is-invalid': submitted && !form.organizacion1.tipo }"
        required
      >
        <option value="">Selecciona...</option>
        <option>comunidad</option>
        <option>institución</option>
        <option>fundación</option>
      </select>
    </div>
    <div class="mb-3">
      <label class="required">Nombre de la comunidad, institución o fundación</label>
      <input
        v-model="form.organizacion1.nombre"
        class="form-control"
        :class="{ 'is-invalid': submitted && !form.organizacion1.nombre }"
        required
      />
    </div>
    <div class="mb-3">
      <label class="required">Fotos</label>
      <input
        type="file"
        multiple
        accept="image/*"
        @change="handleFile($event, 'organizacion1')"
        class="form-control"
        :class="{ 'is-invalid': submitted && files.organizacion1.length === 0 }"
      />
      <small class="text-muted">{{ files.organizacion1.length }} imagen(es) seleccionada(s)</small>
    </div>
    <div class="row mt-2" v-if="previews.organizacion1.length">
      <div class="col-4 col-md-3 col-lg-2 mb-2 position-relative" v-for="(img, index) in previews.organizacion1" :key="'org1-' + index">
        <img
          :src="img"
          class="img-thumbnail w-100 shadow-sm"
          style="height: 100px; object-fit: cover;"
        />
        <button
          type="button"
          class="btn btn-danger btn-sm rounded-circle d-flex align-items-center justify-content-center position-absolute"
          style="width: 24px; height: 24px; top: 4px; right: 4px; z-index: 2;"
          @click="removeImage('organizacion1', index)"
          title="Eliminar imagen"
        >
          <span style="font-size: 16px; line-height: 1;">&times;</span>
        </button>
      </div>
    </div>

    <h5 class="mt-4">Organización 2</h5>
    <div class="mb-3">
      <label>Selecciona una comunidad, institución o fundación</label>
      <select v-model="form.organizacion2.tipo" class="form-select">
        <option value="">Selecciona...</option>
        <option>comunidad</option>
        <option>institución</option>
        <option>fundación</option>
      </select>
    </div>
    <div class="mb-3">
      <label>Nombre de la comunidad, institución o fundación</label>
      <input v-model="form.organizacion2.nombre" class="form-control" />
    </div>
    <div class="mb-3">
      <label>Fotos</label>
      <input type="file" multiple accept="image/*" @change="handleFile($event, 'organizacion2')" class="form-control" />
      <small class="text-muted">{{ files.organizacion2.length }} imagen(es) seleccionada(s)</small>
    </div>
    <div class="row mt-2" v-if="previews.organizacion2.length">
      <div
        class="col-4 col-md-3 col-lg-2 mb-2 position-relative"
        v-for="(img, index) in previews.organizacion2"
        :key="'org2-' + index"
      >
        <img
          :src="img"
          class="img-thumbnail w-100 shadow-sm"
          style="height: 100px; object-fit: cover;"
        />
        <button
          type="button"
          class="btn btn-danger btn-sm rounded-circle d-flex align-items-center justify-content-center position-absolute"
          style="width: 24px; height: 24px; top: 4px; right: 4px; z-index: 2;"
          @click="removeImage('organizacion2', index)"
          title="Eliminar imagen"
        >
          <span style="font-size: 16px; line-height: 1;">&times;</span>
        </button>
      </div>
    </div>

    <button type="submit" class="btn btn-primary mt-3 w-100" :disabled="isSubmitting">{{ isSubmitting ? 'Enviando...' : 'Enviar' }}</button>
  </form>
</template>

<script setup>
import Swal from 'sweetalert2';
import { ref, watch } from 'vue';
import { enviarRegistro } from '../services/api';

const INITIAL_FORM = {
  nombres: '',
  apellidos: '',
  rol: '',
  rol_especificado: '',
  email: '',
  celular: '',
  tipoEntidad: '',
  nameEntity: '',
  organizacion1: { tipo: '', nombre: '' },
  organizacion2: { tipo: '', nombre: '' },
};

const form = ref({ ...INITIAL_FORM });

const files = ref({
  organizacion1: [],
  organizacion2: [],
});

const previews = ref({
  organizacion1: [],
  organizacion2: [],
});

const isSubmitting = ref(false);
const submitted = ref(false);
const confirmedOnce = ref(false);

watch(() => form.value.rol, (newRol) => {
  if (newRol !== 'otro') {
    form.value.rol_especificado = '';
  }
});

const handleFile = (event, key) => {
  const selectedFiles = Array.from(event.target.files);
  const currentFiles = files.value[key];

  if (currentFiles.length + selectedFiles.length > 3) {
    Swal.fire(
      'Límite de imágenes',
      'Solo puedes subir un máximo de 3 imágenes por organización.',
      'warning'
    );
    event.target.value = '';
    return;
  }

  files.value[key] = [...currentFiles, ...selectedFiles];

  const newPreviews = selectedFiles.map(file => URL.createObjectURL(file));
  previews.value[key].push(...newPreviews);

  event.target.value = '';
};

const removeImage = (key, index) => {
  files.value[key].splice(index, 1);
  URL.revokeObjectURL(previews.value[key][index]);
  previews.value[key].splice(index, 1);
};

const revokeAllPreviews = () => {
  for (const key of ['organizacion1', 'organizacion2']) {
    previews.value[key].forEach(url => URL.revokeObjectURL(url));
  }
};

const cleanDataBeforeSend = () => {
  const dataToSend = { ...form.value };

  if (dataToSend.rol !== 'otro') {
    delete dataToSend.rol_especificado;
  }

  const org = dataToSend.organizacion2;
  if (!org?.tipo?.trim() || !org?.nombre?.trim()) {
    delete dataToSend.organizacion2;
  }

  return dataToSend;
};

const onlyText = v => /^[A-Za-zÁ-ÿ\s]+$/.test(v);
const validEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
const validImages = filesArr => {
  if (filesArr.length !== 3) return false;
  return filesArr.every(file => ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type));
};

const validateForm = () => {
  const f = form.value;

  if (!f.nombres?.trim()) return 'El campo "Nombre del profesional" es obligatorio.';
  if (!onlyText(f.nombres)) return 'El campo "Nombre del profesional" solo permite letras y espacios.';
  if (!f.apellidos?.trim()) return 'El campo "Apellidos" es obligatorio.';
  if (!onlyText(f.apellidos)) return 'El campo "Apellidos" solo permite letras y espacios.';
  if (!f.rol) return 'Debes seleccionar una opción en "Rol".';
  if (!validEmail(f.email)) return 'El campo "Email" debe contener un correo válido sin espacios.';
  if (!f.tipoEntidad) return 'Debes seleccionar un tipo de entidad.';
  if (!f.nameEntity?.trim()) return 'El campo "Nombre de la entidad" es obligatorio.';
  if (!onlyText(f.nameEntity)) return 'El campo "Nombre de la entidad" solo permite letras y espacios.';

  const org1 = f.organizacion1;
  if (!org1.tipo) return 'Debes seleccionar un tipo en Organización 1.';
  if (!org1.nombre?.trim()) return 'El nombre de Organización 1 es obligatorio.';
  if (!onlyText(org1.nombre)) return 'El nombre de Organización 1 solo permite letras y espacios.';
  if (!validImages(files.value.organizacion1)) return 'Debes subir exactamente 3 imágenes en Organización 1 en formato PNG, JPEG o JPG.';

  const org2 = f.organizacion2;
  const hasData2 = org2.tipo || org2.nombre || files.value.organizacion2.length > 0;
  if (hasData2) {
    if (!org2.tipo) return 'Debes seleccionar un tipo en Organización 2 o dejarla vacía.';
    if (!org2.nombre?.trim()) return 'El nombre de Organización 2 es obligatorio si completas el tipo.';
    if (!onlyText(org2.nombre)) return 'El nombre de Organización 2 solo permite letras y espacios.';
    if (!validImages(files.value.organizacion2)) return 'Debes subir exactamente 3 imágenes válidas en Organización 2 si decides completarla.';
  }

  return null;
};

const handleSubmit = async () => {
  submitted.value = true;

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  const error = validateForm();
  if (error) {
    isSubmitting.value = false;
    Swal.fire('Error de validación', error, 'error');
    return;
  }

  if (!confirmedOnce.value) {
    const confirm = await Swal.fire({
      title: '¿Confirmar envío?',
      text: 'Estás a punto de registrar esta información. ¿Deseas continuar?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, enviar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirm.isConfirmed) {
      isSubmitting.value = false;
      return;
    }
    confirmedOnce.value = true;
  }

  const formData = new FormData();
  const cleanData = cleanDataBeforeSend();
  formData.append('data', JSON.stringify(cleanData));

  for (const key in files.value) {
    files.value[key].forEach(file => {
      formData.append(key, file);
    });
  }

  Swal.fire({
    title: 'Enviando...',
    text: 'Estamos procesando tu registro',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    await enviarRegistro(formData);
    Swal.fire('¡Éxito!', 'Tu registro ha sido enviado.', 'success');

    revokeAllPreviews();
    form.value = { ...INITIAL_FORM };
    files.value = { organizacion1: [], organizacion2: [] };
    previews.value = { organizacion1: [], organizacion2: [] };
    submitted.value = false;
    confirmedOnce.value = false;
  } catch (err) {
    submitted.value = false;
    Swal.fire('Error', err.response?.data?.message || 'Error al enviar el formulario.', 'error');
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<style scoped>
form {
  background-color: #f8f9fa;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  font-family: 'ColgateReady-Regular';
}

label {
  font-weight: 500;
  color: #333;
}

label.required::after {
  content: ' *';
  color: #dc3545;
}

input.form-control,
select.form-select {
  border-radius: 6px;
  border: 1px solid #ccc;
  padding: 0.6rem 0.75rem;
  font-size: 0.95rem;
}

input.form-control:focus,
select.form-select:focus {
  border-color: #6c757d;
  box-shadow: none;
}

input.form-control.is-invalid,
select.form-select.is-invalid {
  border-color: #dc3545;
}

h5 {
  margin-top: 2rem;
  font-size: 1.1rem;
  color: #444;
}

.alert-info {
  background-color: #e9f5ff;
  color: #31708f;
  border-color: #bce8f1;
  border-radius: 6px;
  padding: 1rem;
}

button.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 6px;
}

button.btn-primary:disabled {
  background-color: #7aa7e9;
  border-color: #7aa7e9;
}

img.img-thumbnail {
  border-radius: 6px;
}

small.text-muted {
  font-size: 0.85rem;
}
</style>
